import {
  css,
  FlattenInterpolation,
  ThemedStyledProps,
  FlattenSimpleInterpolation,
} from 'styled-components';
import { key } from 'styled-theme';

import { TextContainerProps } from '../components/Text/types';

type Unit = 'px' | 'pt' | 'em' | 'rem' | '%';
type MediaCss = (
  // Trust me here needs to be any
  ...args: Parameters<typeof css>
) => FlattenInterpolation<ThemedStyledProps<unknown, unknown>>;
type Media = {
  between: (firstBreakpoint: string, lastBreakpoint: string) => MediaCss;
  lessThan: (breakpoint: string) => MediaCss;
  moreThan: (breakpoint: string) => MediaCss;
};

export const elementSize = (
  size: number,
  unit: Unit = 'px',
): FlattenSimpleInterpolation => css`
  width: ${[size, unit].join('')};
  height: ${[size, unit].join('')};
`;

export const fontSize = ({ theme, size = 0 }: TextContainerProps): string =>
  `font-size: ${theme.text.baseSize + size}px;`;

const generateMedia = (): Media => {
  const resolveBreakpoint = (breakpoint: string): string =>
    parseInt(breakpoint, 10) ? breakpoint : key(`breakpoints.${breakpoint}`);

  const between =
    (firstBreakpoint: string, lastBreakpoint: string): MediaCss =>
    (...args) =>
      css`
        @media screen and (min-width: ${resolveBreakpoint(
            firstBreakpoint,
          )}) and (max-width: ${resolveBreakpoint(lastBreakpoint)}) {
          ${css.apply(
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            this,
            args,
          )};
        }
      `;

  const lessThan =
    (breakpoint: string): MediaCss =>
    (...args) =>
      css`
        @media screen and (max-width: ${resolveBreakpoint(breakpoint)}) {
          ${css.apply(
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            this,
            args,
          )};
        }
      `;

  const moreThan =
    (breakpoint: string): MediaCss =>
    (...args) =>
      css`
        @media screen and (min-width: ${resolveBreakpoint(breakpoint)}) {
          ${css.apply(
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            this,
            args,
          )};
        }
      `;

  return { between, moreThan, lessThan };
};

export const media: Media = generateMedia();
